import { Button, Col, Form, Input, message, Row } from "antd";
import { useEffect, useState } from "react";
import { decryptData } from "../../../utils/crypt";
import { API } from "../../../setup/setupAxios";

const InputCustomer = (props) => {
    const { modal, editData, viewMode, hitApi } = props;
    const [form] = Form.useForm();
    const DBAdmin = decryptData(localStorage.getItem('roleAccess'));
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isEditMode = !!editData;
    useEffect(() => {
        if (editData) {
            form.setFieldsValue({
                nama: editData.nama || "",
                jabatan: editData.jabatan|| "",
                username: editData.username || "",
                password: editData.password || "",
                roleAccess: editData.roleAccess || ""
            });
        } else {
            form.resetFields();
        }
    }, [editData, form]);
    const handleCreate = async (values) => {
        const payload = { ...values };
        setIsSubmitting(true);
        try {
            await API.post("/api/admin", payload);
            message.success("Data berhasil disimpan");
            form.resetFields();
            hitApi();
            modal(false);
        } catch (error) {
            console.error("Gagal menyimpan data:", error);
            message.error("Data tidak dapat disimpan");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleUpdate = async (values) => {
        const payload = { id: editData?.id, ...values };
        setIsSubmitting(true);
        try {
            await API.put(`/api/admin/${editData?.username}`, payload);
            message.success("Data berhasil diperbarui");
            hitApi();
            modal(false);
        } catch (error) {
            console.error("Gagal memperbarui data:", error);
            message.error("Data tidak dapat diperbarui");
        } finally {
            setIsSubmitting(false);
        }
    };

    const onFinish = (values) => {
        if (isEditMode) handleUpdate(values);
        else handleCreate(values);
    };

    return (
        <>
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
        >
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label="Nama"
                        name="nama"
                        rules={[{ required: true, message: "Masukkan Nama Karyawan" }]}
                    >
                        <Input disabled={viewMode} />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="Jabatan"
                        name="jabatan"
                        rules={[{ required: true, message: "Masukkan Jabatan Karyawanr" }]}
                    >
                        <Input disabled={viewMode} />
                    </Form.Item>
                </Col>
            </Row>
            {DBAdmin === "DBA" ? (
                <>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Username"
                            name="username"
                            rules={[{ required: true, message: "Masukkan Username Login" }]}
                        >
                            <Input disabled={viewMode} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: "Masukkan Password Login " }]}
                        >
                            <Input disabled={viewMode} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Role Access"
                            name="roleAccess"
                            rules={[{ required: true, message: "Masukkan Role Access User " }]}
                        >
                            <Input disabled={viewMode} />
                        </Form.Item>
                    </Col>
                </Row>
                </>
            ):(
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Username"
                            name="username"
                            rules={[{ required: true, message: "Masukkan Username Login" }]}
                        >
                            <Input disabled={viewMode} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Role Access"
                            name="roleAccess"
                            rules={[{ required: true, message: "Masukkan Role Access User " }]}
                        >
                            <Input disabled={viewMode} />
                        </Form.Item>
                    </Col>
                </Row>
            )}
            {!viewMode && (
                <Row>
                    <Col span={24}>
                        <Button style={{ marginRight: 8 }} onClick={() => modal(false)}>
                            Cancel
                        </Button>

                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={isSubmitting}
                        >
                            {isEditMode ? "Perbarui" : "Simpan"}
                        </Button>
                    </Col>
                </Row>
            )}
        </Form>
        </>
    );
};

export default InputCustomer;